import { render, staticRenderFns } from "./sales-product-detail.vue?vue&type=template&id=27ef21ab&scoped=true"
import script from "./sales-product-detail.vue?vue&type=script&lang=js"
export * from "./sales-product-detail.vue?vue&type=script&lang=js"
import style0 from "./sales-product-detail.vue?vue&type=style&index=0&id=27ef21ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ef21ab",
  null
  
)

export default component.exports